"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ShieldAlert, Crosshair } from "lucide-react";
const faqData = [{
  question: "How frequently should rural properties in Arcadia receive pest control treatments?",
  answer: "For rural and agricultural properties in the Arcadia area, we mandate bi-monthly or quarterly treatments depending on the surrounding environmental pressure. Properties adjacent to dense vegetation, citrus groves, or standing water sources require more frequent, aggressive interventions to effectively manage encroaching wildlife and insect populations before they breach structural perimeters."
}, {
  question: "What are the most common pests specific to the Arcadia region?",
  answer: "Arcadia's unique climate and rural landscape make it highly susceptible to specific, resilient pests. Our data indicates high activity levels for Palmetto bugs (Florida woods cockroaches), aggressive subterranean termite colonies, imported fire ants, and various venomous spider species. Our chemical protocols are specifically calibrated to target and neutralize these local populations."
}, {
  question: "Are your pest control treatments safe for livestock and agricultural animals?",
  answer: "Affirmative. We utilize specialized, targeted application methodologies that prioritize the safety of livestock, equine facilities, and domestic animals. We coordinate strictly with property managers to ensure treatment zones are properly isolated and adhere to all Florida Department of Agriculture and Consumer Services (FDACS) safety guidelines during and after application."
}, {
  question: "Do you offer emergency or rapid-response service for severe infestations?",
  answer: "We recognize that critical pest situations—such as sudden termite swarms or aggressive stinging insect nesting near high-traffic areas—require immediate tactical response. While standard scheduling applies for routine perimeter defense, we maintain dedicated rapid-response capabilities for severe infestations in the Arcadia sector, subject to daily operational availability."
}];
export default function ArcadiaPestFAQ() {
  return <section id="arcadiapestfaq" className="bg-background py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="bg-primary text-primary-foreground p-8 md:p-12 lg:p-16 shadow-2xl rounded-none relative overflow-hidden">
          
          {}
          <div className="absolute top-0 right-0 opacity-5 pointer-events-none translate-x-1/4 -translate-y-1/4">
            <Crosshair className="w-96 h-96" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 relative z-10">
            
            {}
            <div className="lg:col-span-5 flex flex-col justify-start">
              <div className="inline-flex items-center gap-3 mb-6">
                <ShieldAlert className="size-6 text-accent" />
                <span className="font-default text-accent tracking-widest uppercase text-sm font-bold">
                  Technical Specifications
                </span>
              </div>
              
              <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-none mb-6 uppercase tracking-tight">
                Arcadia Area<br />Operations FAQ
              </h2>
              
              <p className="font-serif text-primary-foreground/80 text-lg mb-10 leading-relaxed">
                Detailed operational protocols, safety guidelines, and service specifications for rural, residential, and agricultural properties in the Arcadia region.
              </p>
              
              <Button asChild size="lg" className="w-fit rounded-none bg-accent text-accent-foreground hover:bg-accent/90 font-default uppercase tracking-wider text-base px-8 py-6">
                <Link to="/ContactPage">Request Technical Inspection</Link>
              </Button>
            </div>

            {}
            <div className="lg:col-span-7">
              <Accordion type="single" collapsible className="w-full [&_.text-muted-foreground]:text-accent">
                {faqData.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-primary-foreground/20 rounded-none">
                    <AccordionTrigger className="font-default text-xl md:text-2xl text-left hover:text-accent hover:no-underline rounded-none py-6 transition-colors">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent className="font-serif text-base md:text-lg text-primary-foreground/70 leading-relaxed pb-8 pt-2">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}